import { Component, OnInit, ViewChild, Input, AfterViewInit, ElementRef } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService, SortMeta } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BonCommandeEntite } from '../../entites/bon-commande';
import { ListeAchatService } from '../../services/liste-achat-service';
import { AchatService } from '../../services/achat-service';
import { formaterErreurCtrl } from '../../services/ctrl-erreur';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { AppMainComponent } from 'src/app/app.main.component';
import { Statut } from 'src/app/entites/statut';
import { Subscription } from 'rxjs';
@Component({
    templateUrl: './achats.component.html',
    styleUrls: ['./achats.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService],
    host: {
        '(document:keydown)': 'handleKeyboardEvents($event)'
    }
})
export class AchatsComponent extends BaseComponent implements OnInit, AfterViewInit {

    bonsCommande: BonCommandeEntite[];

    detailBdcId: number;
    afficherDetailBdc: boolean = false;

    statuts: Statut[] = this.sdb.Statuts();

    chargementBdcComplete: boolean = false;
    totalRecords: number = 0;
    lastRequest: Subscription;

    rechercheComplete = this.createParamSignal<boolean>('rechercheComplete', false);

    tableParams = this.createTableFilter();
    globalFilter: string = '';
    sortMeta: SortMeta[] = [
        { field: 'indComplete', order: 1 },
        { field: 'dateAchat', order: -1 },
        { field: 'bonCommandeId', order: -1 }
    ];

    menuContextuel: MenuItem[];

    menu: MenuItem[] = [
        {
            label: 'Forcer la synchronisation CTRL',
            icon: 'pi pi-upload',
            visible: this.profilService.estAutoriseTache('admin_attributs'),
            command: () => this.ForcerSynchronisationCTRL()
        }
    ];

    @ViewChild('dt') table: Table;
    @ViewChild('rechercheBdc') rechercheBdc: ElementRef;
    @ViewChild('menuContextuelItemCommande') menuContextuelItemCommande: ContextMenu;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private achatService: AchatService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de commande' }
        ]);
    }

    ngOnInit() {

        this.verifierAccesPageAuMoisUnAcces(['bdcs', 'bdcs_proprietaire']);

        this.colonnesDisponibles = [
            { champ: 'projet', entete: 'Projet', afficheParDefaut: true },
            { champ: 'nbItems', entete: 'Nb items', afficheParDefaut: false },
            { champ: 'coutTotal', entete: 'Coût total', afficheParDefaut: true },
            { champ: 'employe', entete: 'Employé', afficheParDefaut: true },
            { champ: 'dateEnvoi', entete: 'Date d\'envoi', afficheParDefaut: true },
            { champ: 'envoyeA', entete: 'Envoyé à', afficheParDefaut: true }
        ];
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.CompleterChargement();
    }

    ngAfterViewInit(): void {
        this.sortMeta = this.tableParams.getValue().multiSortMeta ?? this.sortMeta;
        this.globalFilter = this.tableParams.getValue().globalFilter;
        this.chargerColonnesSelectionnees();
    }

    handleKeyboardEvents(event: KeyboardEvent) {
        // if (event.key == '+') {
        //     this.AjouterBdc();
        // }
    }

    menuContextuelEntrees: MenuItem[];
    surMenuContextuelItem(event, bonCommande: BonCommandeEntite) {

        this.menuContextuelEntrees = [
            {
                label: 'Voir le fournisseur',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('fournisseur_detail'),
                command: () => this.routerService.navigateByUrl('fournisseur/' + bonCommande.fournisseur.fournisseurId)
            },
            {
                label: 'Rendre privé',
                icon: 'icon-hat-glasses',
                visible: this.estAutorise('bdc_action_rendre_prive')
                    && this.estCreateur(bonCommande)
                    && !bonCommande.indPrive,
                command: () => this.rendreBonCommandeIndPrive(bonCommande, true)
            },
            {
                label: 'Rendre public',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('bdc_action_rendre_prive')
                    && this.estCreateur(bonCommande)
                    && !!bonCommande.indPrive,
                command: () => this.rendreBonCommandeIndPrive(bonCommande, false)
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-times',
                visible: this.estAutorise('bdc_supprimer'),
                disabled: bonCommande.statut.statutId != EStatuts.EnCours,
                styleClass: 'menuSuppression',
                command: () => this.supprimerBonCommande(bonCommande)
            }
        ];

        this.menuContextuelItemCommande.toggle(event);
    }

    estCreateur(bonCommande: BonCommandeEntite): boolean {
        return bonCommande.employe?.employeId === this.profilService.ProfilCourant()?.employeId;
    }

    rendreBonCommandeIndPrive(bonCommande: BonCommandeEntite, indPrive: boolean) {
        this.confirmationService.confirm({
            message: indPrive
                ? 'Ce bon de commande ne sera plus visible que par vous. Continuer ?'
                : 'Ce bon de commande redeviendra visible pour les utilisateurs autorisés. Continuer ?',
            header: indPrive ? 'Rendre privé' : 'Rendre public',
            icon: indPrive ? 'pi pi-eye-slash' : 'pi pi-eye',
            accept: () => {
                this.achatService.RendreBonsCommandePrivesLot([bonCommande.bonCommandeId], indPrive).then(res => {
                    if (res.estUnSucces) {
                        bonCommande.indPrive = indPrive;
                        this.achatService.ClearCacheBonsCommande();
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: indPrive ? 'Bon de commande rendu privé.' : 'Bon de commande rendu public.'
                        });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    supprimerBonCommande(bonCommande: BonCommandeEntite) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer le bon de commande sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.achatService.SupprimerBonCommande(bonCommande.bonCommandeId).then(res => {
                    if (res.estUnSucces) {
                        this.bonsCommande = this.bonsCommande.filter(val => val.bonCommandeId != bonCommande.bonCommandeId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de commande supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    AjouterBdc() {
        this.routerService.navigateByUrl("achat/nouveau")
    }

    OuvrirDetailBdc(bonCommandeId: number) {
        this.routerService.navigateByUrl(`achat/${bonCommandeId}`)
    }

    OuvrirDetailBdcNouvelOnglet(itemId: number) {
        this.detailBdcId = itemId;
        this.afficherDetailBdc = true;
    }

    readonly formaterErreurCtrl = formaterErreurCtrl;

    ForcerSynchronisationCTRL() {
        this.messageService.add({
            severity: 'info',
            summary: 'Synchronisation CTRL',
            detail: 'Cette opération peut prendre plusieurs minutes.',
            key: 'synchronisationCTRL',
            sticky: true
        });
        this.achatService.ForcerSynchronisationCTRL().subscribe(x => {
            if (x.estUnSucces) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Synchronisation CTRL forcée. Actualisation en cours...' });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la synchronisation CTRL.' });
            }
            this.messageService.clear('synchronisationCTRL');

            setTimeout(() => {
                this.routerService.navigateByUrl('/').then(() => {
                    this.routerService.navigateByUrl('/achats');
                });
            }, 2000);
        });
    }

    async onLazyLoad(event: LazyLoadEvent) {

        while (!this.table) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        this.tableParams.setValue(this.table);

        this.chargementBdcComplete = false;

        // Cancel previous request if still running
        if (this.lastRequest) {
            this.lastRequest.unsubscribe();
        }

        // Load current page
        this.lastRequest = this.achatService.ObtenirBonsCommande(null, this.estAutorise('bdcs') ? null : this.profilService.ProfilCourant().employeId, this.rechercheComplete(), event).subscribe({
            next: x => {
                this.bonsCommande = x.elements ?? [];
                this.totalRecords = x.maxCount ?? 0;
                this.chargementBdcComplete = true;
                this.prefetch(event);
            },
            error: () => {
                this.bonsCommande = [];
                this.totalRecords = 0;
                this.chargementBdcComplete = true;
            }
        });
    }

    rechercheCompleteChanged(event: any) {
        this.onLazyLoad(this.tableParams.getValue());
    }

    prefetch(event: LazyLoadEvent) {
        // Async prefetch previous page
        if (event.first > 0) {
            const prevEvent = { ...event, first: event.first - event.rows };
            this.achatService.ObtenirBonsCommande(null, this.estAutorise('bdcs') ? null : this.profilService.ProfilCourant().employeId, this.rechercheComplete(), prevEvent).subscribe();
        }

        // Async prefetch next page
        if (event.first + event.rows < this.totalRecords) {
            const nextEvent = { ...event, first: event.first + event.rows };
            this.achatService.ObtenirBonsCommande(null, this.estAutorise('bdcs') ? null : this.profilService.ProfilCourant().employeId, this.rechercheComplete(), nextEvent).subscribe();
        }
    }

    clearFilters(table: Table) {
        table.reset();
        table.clear();
        this.globalFilter = '';
        this.sortMeta = [
            { field: 'indComplete', order: 1 },
            { field: 'dateAchat', order: -1 },
            { field: 'bonCommandeId', order: -1 }
        ];
    }
}
